import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
const articles = [{
  title: "You Don't Have a Measurement Problem, You Have a Courage Problem",
  href: '#'
}, {
  title: 'The Agentic Decision Crisis',
  href: '#'
}, {
  title: 'Trust Engineering: Why AI Systems Fail at the Organizational Layer',
  href: '#'
}];
export function Writing() {
  return <section id="writing" className="py-24 md:py-32 border-t border-border" data-id="element-189">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-190">
        <div className="mb-16" data-id="element-191">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary tracking-tight" data-id="element-192">
            Writing & Open Source
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-193">
          {/* Writing Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="glass-card p-8 md:p-10 rounded-2xl flex flex-col h-full" data-id="element-194">
            <h3 className="text-2xl font-semibold text-primary mb-4 tracking-tight" data-id="element-195">
              Writing
            </h3>
            <p className="text-secondary text-lg leading-relaxed mb-6" data-id="element-196">
              I write about decision systems, AI governance, and the
              organizational failures that kill enterprise AI.
            </p>

            <div className="space-y-3 mb-8 flex-grow" data-id="element-197">
              {articles.map((article, index) => <a key={index} href={article.href} className="flex items-start gap-2 text-primary hover:text-gold transition-colors group" data-id="element-198">
                  <ArrowUpRight className="w-4 h-4 mt-0.5 shrink-0 text-secondary group-hover:text-gold transition-colors" data-id="element-199" />
                  <span className="text-sm font-medium leading-snug" data-id="element-200">
                    {article.title}
                  </span>
                </a>)}
            </div>

            <a href="https://substack.com/@karandhir" target="_blank" rel="noopener noreferrer" className="flex items-center text-gold text-sm font-medium group" data-id="element-201">
              Read on Substack
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-202" />
            </a>
          </motion.div>

          {/* Open Source Card */}
          <motion.a href="https://github.com/kd-511" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="glass-card p-8 md:p-10 rounded-2xl group hover:border-gold/30 transition-colors flex flex-col h-full" data-id="element-203">
            <h3 className="text-2xl font-semibold text-primary mb-4 tracking-tight" data-id="element-204">
              Open Source
            </h3>
            <p className="text-secondary text-lg leading-relaxed mb-8 flex-grow" data-id="element-205">
              Architecture patterns for AI-native marketing mix modeling:
              governance gates, stability frameworks, and closed-loop decision
              systems.
            </p>
            <div className="flex items-center text-gold text-sm font-medium" data-id="element-206">
              View on GitHub
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-207" />
            </div>
          </motion.a>
        </div>
      </div>
    </section>;
}